import { useEffect, useRef, useState } from "react";
import { Fluid, drawFog } from "@/lib/fluid";
import { useTheme } from "@/context/ThemeContext";

export const FluidLayer = ({ heroRef, onFallback }) => {
  const hostRef = useRef(null);
  const fluidRef = useRef(null);
  const [fallback, setFallback] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) { setFallback(true); onFallback?.(); return; }
    let fluid;
    try {
      fluid = new Fluid(hostRef.current, drawFog, {});
    } catch {
      setFallback(true); onFallback?.(); return;
    }
    fluidRef.current = fluid;
    let first = true;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { fluid.start(); if (first) { first = false; fluid.auto = performance.now(); } }
      else fluid.stop();
    }));
    io.observe(heroRef.current);
    return () => {
      io.disconnect(); fluid.stop(); fluid.ro.disconnect();
      removeEventListener("pointermove", fluid.onMove);
      removeEventListener("touchmove", fluid.onTouch);
      fluid.gl.getExtension("WEBGL_lose_context")?.loseContext();
      fluid.canvas.remove();
      fluidRef.current = null;
    };
  }, [heroRef, onFallback]);

  useEffect(() => {
    if (fluidRef.current) requestAnimationFrame(() => fluidRef.current?.resize());
  }, [theme]);

  return <div ref={hostRef} className={fallback ? "hero-fallback" : "fluid-host"} aria-hidden="true" />;
};
